import AWS from 'aws-sdk'
import store from '@/store'

const S3Client = {
  /**
   * Returns S3 Service with authenticated user credentials
   * Usage:
   *    const s3Service = await getService()
   *    const s3Upload = new AWS.S3.ManagedUpload({
   *      service: s3Service,  <<= USE HERE
   *      params: {
   *        Bucket: payload.bucket,
   *        Key: payload.key,
   *        Body: payload.file
   *      }
   *     })
   *   -or-
   *   const s3Client = await getService()
   *   s3Client.listObjectsV2(...)
   */
  async getService () {
    await store.dispatch('getCurrentUser') // refresh tokens for s3 upload...
    const credentials = await store.dispatch('getUserCredentials')

    return new AWS.S3({
      credentials: credentials,
      signatureVersion: 'v4',
      apiVersion: '2006-03-01',
      region: process.env.VUE_APP_COGNITO_REGION
    })
  }
}

export default S3Client
